import React from 'react';
import './App.css';

function SMSTexting() {
  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src={require('./logo_no_text.png')} alt="Estate Parrot Logo" className="logo-image" />
            <span className="logo-text">Estate Parrot</span>
          </div>
          
          <div className="nav-center">
            <button className="nav-menu-toggle">SMS Texting</button>
          </div>

          <div className="nav-menu">
            <a href="/" className="nav-link">Back to Main Site</a>
          </div>
        </div>
      </nav>

      {/* SMS Texting Hero */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-logo">
              <img src={require('./logo_no_text.png')} alt="Estate Parrot Logo" className="hero-logo-image" />
            </div>
            <h1 className="hero-title">
              SMS Texting Feature
            </h1>
            <p className="hero-subtitle">
              Coming soon: Text Estate Parrot directly for even faster real estate automation. No email required.
            </p>
          </div>
          <div className="hero-image">
            <div className="estate-ui">
              <div className="ui-window">
                <div className="ui-header">
                  <div className="ui-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className="ui-content">
                  <div className="ui-message">
                    <p className="ui-test-prompt">Try SMS texting!</p>
                  </div>
                  <div className="sms-example">
                    <div className="sms-bubble user">
                      Create listing for 789 Pine St, 4 bed 3 bath, $520k
                    </div>
                    <div className="sms-bubble bot">
                      ✅ Listing created and published to SmartMLS!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SMS Features */}
      <section className="undetectable" id="features">
        <div className="container">
          <h2 className="section-title">SMS Texting Benefits</h2>
          <p className="section-subtitle">Even faster than email - text Estate Parrot for instant real estate automation.</p>

          <div className="undetectable-features">
            <div className="undetectable-card">
              <div className="card-image">
                <div className="meeting-mockup">
                  <div className="meeting-header">
                    <span className="meeting-title">Instant Response</span>
                    <span className="meeting-participants">Real-time</span>
                  </div>
                  <div className="meeting-content">
                    <div className="participant-grid">
                      <div className="participant"></div>
                      <div className="participant"></div>
                      <div className="participant"></div>
                      <div className="participant"></div>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Instant Notifications</h3>
              <p>Get immediate confirmations and updates via SMS. No need to check email constantly.</p>
            </div>

            <div className="undetectable-card">
              <div className="card-image">
                <div className="screen-share-mockup">
                  <div className="screen-content">
                    <div className="presentation-slide">
                      <h4>Mobile First</h4>
                      <div className="chart-placeholder"></div>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Mobile Optimized</h3>
              <p>Perfect for agents on the go. Send quick texts from anywhere, anytime.</p>
            </div>

            <div className="undetectable-card">
              <div className="card-image">
                <div className="eye-tracking-mockup">
                  <div className="screen-overlay">
                    <div className="estate-window">
                      <div className="window-header"></div>
                      <div className="window-content">
                        <p>Text received!</p>
                      </div>
                    </div>
                    <div className="eye-indicator"></div>
                  </div>
                </div>
              </div>
              <h3>Simple Commands</h3>
              <p>Use natural language. No special commands or formatting required.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Notice */}
      <section className="use-cases">
        <div className="container">
          <h2 className="section-title">Available Soon</h2>
          
          <div className="use-cases-content">
            <div className="use-case active">
              <div className="use-case-text">
                <h3>SMS Texting Launch</h3>
                <p><strong>📱 Direct SMS</strong> - Text directly to Estate Parrot's phone number</p>
                <p><strong>🚀 Faster Response</strong> - Get confirmations in seconds, not minutes</p>
                <p><strong>📋 All Current Features</strong> - Everything you can do via email, now via text</p>
                <p><strong>🔔 Smart Notifications</strong> - Get updates on signatures, deadlines, and more</p>
              </div>
              <div className="use-case-visual">
                <div className="email-mockup">
                  <div className="sms-conversation">
                    <div className="sms-bubble user">Need contract for 456 Oak Ave, buyer Sarah Jones, $380k, close Feb 28</div>
                    <div className="sms-bubble bot">Got it! Creating purchase agreement now...</div>
                    <div className="sms-bubble bot">✅ Contract ready! Sent to Sarah for signature. You'll get notified when signed.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className="simple-footer">
        <div className="container">
          <p>Estate Parrot 2025. All Rights Reserved</p>
        </div>
      </footer>
    </div>
  );
}

export default SMSTexting; 